import apiClient from "@shared/services/apiClient";
import { getBrowserTelemetry } from "@shared/services/telemetry";
import { getOrganizationSlugFromHostname } from "@shared/utils/orgLoginRouting";
import {
  isSuppressedFeatureDenialCode,
  type SuppressedFeatureDenialCode,
} from "@shared/constants/suppressedFeatureDenialCodes";

export type { SuppressedFeatureDenialCode };

type SuppressedFeatureDenialEventDetail = {
  code?: unknown;
  url?: unknown;
  method?: unknown;
  status?: unknown;
  feature?: unknown;
  organization_id?: unknown;
  required_permission?: unknown;
  timestamp?: unknown;
};

export async function trackSuppressedFeatureDenial(
  detail: SuppressedFeatureDenialEventDetail,
): Promise<void> {
  const code = String(detail.code || "").trim();
  if (!isSuppressedFeatureDenialCode(code)) {
    return;
  }

  const browserTelemetry = getBrowserTelemetry();
  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";
  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "";

  await apiClient.post("/auth/feature-denial-telemetry", {
    code,
    url: typeof detail.url === "string" ? detail.url : undefined,
    method: typeof detail.method === "string" ? detail.method : undefined,
    status:
      typeof detail.status === "number" && Number.isFinite(detail.status)
        ? detail.status
        : undefined,
    feature: typeof detail.feature === "string" ? detail.feature : undefined,
    organization_id:
      typeof detail.organization_id === "string"
        ? detail.organization_id
        : undefined,
    required_permission:
      typeof detail.required_permission === "string"
        ? detail.required_permission
        : undefined,
    event_ts:
      typeof detail.timestamp === "string"
        ? detail.timestamp
        : new Date().toISOString(),
    source: "serviceapi-permission-handler",
    current_path: pathname || undefined,
    org_slug: hostname ? getOrganizationSlugFromHostname(hostname) : undefined,
    ...browserTelemetry,
  });
}
